import React, { useState, useMemo } from 'react'
import StorePagination from 'app/views/partners/StorePagination'
import { stores } from 'app/views/partners/staticData'
import { AccessTime, ThreeDRotation } from '@material-ui/icons'
import styled from 'styled-components'
import { devices } from 'utils/screen_sizes'

import {
    StyledSloganSection,
    SecondarySlogan,
    PrimarySlogan,
    PartnerSecondarySlogan,
    StyledStoresSection,
} from './Stores.style'
import { MatxModal, GoogleMap } from 'app/components'
import { useTranslation } from 'react-i18next'

const StyledHeader = styled.div`
    background-image: url(${(props) => props.img});
    /* padding: 20rem; */
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left;
    background-position: -40px;
    position: relative;
    margin: 2rem 0;

    h3 {
        margin-left: 1.2rem;
        color: #000;
    }
    @media ${devices.mobileS} {
         background-image: url("");
           background-position: -40px;
        width: 80vw;
        margin: 2rem auto;
        flex-direction: column;
      
       
    }
    @media ${devices.laptop} {
         background-image: url(${(props) => props.img});
           background-position: -40px;
         width: 75vw;
          margin: 2rem auto;
        flex-direction: row;
       
    
    @media ${devices.desktop} {
          background-position: -20px;
    }
`

const isOpen = () => {
    let start = 8 * 60 + 0
    let end = 18 * 60 + 0

    // between 8 AM and 6PM
    var now = new Date()
    var time = now.getHours() * 60 + now.getMinutes()
    return time >= start && time < end
}

const Stores = ({ source = true }) => {
    const { t } = useTranslation()
    const [currentPage, setCurrentPage] = useState(1)
    const [store, setStore] = useState({})
    const [open, setOpen] = React.useState(false)

    let PageSize = 4

    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return stores.slice(firstPageIndex, lastPageIndex)
    }, [currentPage])

    const handleOpen = (store) => {
        setOpen(true)
        setStore(store)
    }

    const handleClose = () => {
        setOpen(false)
        setStore({})
    }

    return (
        <>
            {source ? (
                <StyledSloganSection>
                    <MatxModal open={open} handleClose={handleClose}>
                        <GoogleMap
                            name={store.store_name}
                            lat={store.lat}
                            lng={store.lng}
                        />
                    </MatxModal>
                    {/* <StyledHeader img="/assets/images/offline-stores/kiosk-banner.svg">
                        <h3>Find an Authorized Badili Buyback Partner</h3>
                    </StyledHeader>
                    <StyledStoresSection>
                        {currentTableData.map((store, i) => (
                            <div className="store-card" key={i}>
                                <h4>{store.store_name}</h4>
                                <p className="store-location">
                                    {store.store_location}
                                </p>
                                {store.contact && (
                                    <p className="store-location">
                                        {store.contact}
                                    </p>
                                )}
                                <div className="store-card-footer">
                                    <div>
                                        {' '}
                                        <div
                                            className="open-store"
                                            style={{
                                                color: `${
                                                    isOpen()
                                                        ? '#2aa839'
                                                        : '#df4759'
                                                }`,
                                            }}
                                        >
                                            <AccessTime
                                                fontSize="small"
                                                className="mr-2"
                                            />{' '}
                                            {isOpen() ? 'Open Now' : 'Closed'}
                                        </div>
                                    </div>

                                    
                                </div>
                            </div>
                        ))}
                    </StyledStoresSection>
                    <StorePagination
                        className="pagination-bar mb-5"
                        currentPage={currentPage}
                        totalCount={stores.length}
                        pageSize={PageSize}
                        onPageChange={(page) => setCurrentPage(page)}
                    /> */}
                    <SecondarySlogan>
                        <h4>{t('description.slogan')}</h4>
                    </SecondarySlogan>
                </StyledSloganSection>
            ) : (
                <StyledSloganSection>
                    <SecondarySlogan>
                        <h4>Africa's First and Largest Online Mobile Expert</h4>
                    </SecondarySlogan>
                    <PrimarySlogan>
                        <h1>Chagua Badili, wacha kujadili</h1>
                       
                    </PrimarySlogan>
                </StyledSloganSection>
            )}
        </>
    )
}

export default Stores
